/**
 * The page's theme colour, which browsers (and the iOS app, under the status
 * bar) show around it: the header's, or on a page without one, the background
 * at the top of the window.
 */
const topBackgroundColor = () => {
  // Even when scrolled away, as a kept tab comes back scrolled down
  const header = document.getElementById("header");
  if (header?.offsetParent) {
    return getComputedStyle(header).backgroundColor;
  }
  let element = document.elementFromPoint(window.innerWidth / 2, 0);
  while (element) {
    const { backgroundColor } = getComputedStyle(element);
    if (backgroundColor !== "rgba(0, 0, 0, 0)") {
      return backgroundColor;
    }
    element = element.parentElement;
  }
  return getComputedStyle(document.body).backgroundColor;
};

export const update = () => {
  document
    .querySelector('meta[name="theme-color"]')
    ?.setAttribute("content", topBackgroundColor());
};
